export const getCookie = (name) => {
    const cookieName = `${name}=`;
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();

        if (cookie.indexOf(cookieName) === 0) {
            return decodeURIComponent(cookie.substring(cookieName.length));
        }
    }

    return "";
};

export const captureAttribution = () => {
    if (getCookie('attribution_data')) {
        return;
    }

    const params = new URLSearchParams(window.location.search);
    const attributionData = {
        gclid: params.get('gclid') || "",
        fbclid: params.get('fbclid') || "",
        utm_source: params.get('utm_source') || "",
        utm_medium: params.get('utm_medium') || "",
        utm_campaign: params.get('utm_campaign') || "",
        referrer: document.referrer || "",
        landing_page: window.location.href,
        captured_at: new Date().toISOString()
    };

    const hasAttributionData = attributionData.gclid ||
        attributionData.fbclid ||
        attributionData.utm_source ||
        attributionData.utm_medium ||
        attributionData.utm_campaign ||
        attributionData.referrer;

    if (!hasAttributionData) {
        return;
    }

    document.cookie = `attribution_data=${encodeURIComponent(JSON.stringify(attributionData))}; path=/; max-age=2592000; SameSite=Lax`;
};
